import { RequestPublicGuestlistBody } from './types';

const BASE_URL = process.env.PREACT_APP_BASE_URL;

export const fetchOptions: RequestInit = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'api-target': 'rest',
  },
  mode: 'cors',
};

export const requestPublicGuestlist = async (
  clubId: number,
  requestBody: RequestPublicGuestlistBody,
): Promise<Response> => {
  const options: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Request-Headers': 'api-target',
      'api-target': 'rest',
    },
    body: JSON.stringify(requestBody),
  };

  return fetch(
    `${BASE_URL}/public-guest-lists/${clubId}`,
    Object.assign({}, fetchOptions, options),
  );
};

export const getClubEventItems = async (
  clubId: number,
): Promise<Response> => {
  return fetch(
    `${BASE_URL}/public-guest-lists/${clubId}`,
    fetchOptions,
  );
};
